<script>
export default {
  name: "RedirectToSelect",
  beforeMount() {
    this.$router.push({ name: 'wp__select' })
  }
}
</script>
